import { getBetAggr } from "./getBetAggr";

export function getAggregationAndBetFromBetIdAndSportId(sportId, scomSogei, handicap) {
	let aggList = window.xs_ag.agsByBetIdAndSportId[`${sportId}_${scomSogei}_${handicap}`];
	if (!aggList && handicap != 0) {
		aggList = window.xs_ag.agsByBetIdAndSportId[`${sportId}_${scomSogei}_0`];
	}
	let market = null;
	let aggregation = null;
	const allAggregations = {};
	if (aggList) {
		let minorIndex = 0;
		let ranking = -1;
		let principaleFound = false;
		for (let ka in aggList) {
			allAggregations[aggList[ka].idAggregata] = aggList[ka]; // le salvo tutte, nell'altro campo "aggregation" ci sarà la migliore
			if (!principaleFound && (aggList[ka].isPrincipale || aggList[ka].ranking < ranking || ranking === -1)) {
				minorIndex = ka;
				ranking = aggList[ka].ranking;
				if (aggList[ka].isPrincipale) {
					principaleFound = true;
				}
			}
		}

		aggregation = aggList[minorIndex];
		for (let ks in aggregation.scommesse) {
			const bet = aggregation.scommesse[ks];
			if (bet.id === scomSogei) {
				if (bet.handicap == handicap) { // NB: handicap in the bet object could be string: then "==" instead of "==="
					market = bet; // the specific line has the priority in the case when the aggregate contains the parametric markets and ALSO the specific lines
				}
				else if (bet.handicap == 0 && handicap != 0 && !market) {
					market = bet;
				}
			
			}
		}
	}
	if (!market) {
		market = getBetAggr(scomSogei, handicap);
	}
	
	return {
		market, // il mercato
		aggregation, // l'aggregazione migliore
		allAggregations // tutte le aggregate in cui compare
	};
}
window.getAggregationAndBetFromBetIdAndSportId = getAggregationAndBetFromBetIdAndSportId;
